<template>
	<div class="form-section-container">
		<div class="action">
			<small><span>Select active currencies</span></small><br>
            <dynamic-select
				ref="activeSelect"
                store="Currencies"
                storePath="items"
				:displayPhrase="(item) => `${item.Name} (${item.Code})`"
				:cleanApi="true"
				classes="font-weight-bolds"
				style="margin-bottom:15px;display:inline-block;"
				></dynamic-select>
            <button
                type="button"
				@click.prevent="add()"
                class="btn btn-green" style="margin-left:15px;font-size:16px;height:30px;padding: 0 1em;">ADD</button>
			<div class="dashed-container">
				<label
					:key="item.Id"
					v-for="item in tempItems"
					:title="displayInput === JSON.stringify(item) ? `selected as default currency` : 'click to set as default currency'">
					<input type="radio" name="project.currency.display" v-model="displayInput" :value="JSON.stringify(item)" />
					<span>{{ item.Name }}</span> <font-awesome-icon
								@click.prevent="rem(item)"
								title="remove"
								:icon="['fas', 'times']"></font-awesome-icon>
					<input type="hidden" :name="inputName" :value="JSON.stringify(item)">
				</label>
			</div>
			<small><span>Select provider currency <tooltip text="flights/hotels currency from IRIX"></tooltip></span></small><br>
			<dynamic-select
				ref="providerSelect"
                store="Currencies"
                storePath="items"
				name="project.currency.provider"
				:displayPhrase="(item) => `${item.Name} (${item.Code})`"
				@change="hndDynamicSelectEmit($event)"
                :value="providerInput"
				:stringifiedValue="true"
				:cleanApi="true"
				classes="font-weight-bolds"
				style="margin-bottom:15px;"
				></dynamic-select>
		</div>
	</div>
</template>
<script>
import Typeahead from '@/components/shared/Typeahead'
import Tooltip from '@/components/TooltipIcon'
import DynamicSelect from '@/components/shared/DynamicSelect'
export default {
	components: {
		'typeahead': Typeahead,
		'tooltip': Tooltip,
		'dynamic-select': DynamicSelect
	},
	props: {
		'inputName': {
			type: String,
			required: true
		},
		'inputValue': {
			type: [String, Number],
			required: true
		},
		'tempParentItems': {
			type: Array,
			required: false,
			default: () => []
		},
		'displayItem': {
			type: String,
			required: false,
			default: ''
		},
		'providerItem': {
			type: String,
			required: false,
			default: ''
		}
	},
	data () {
		return {
			val: '',
			providerInput: '',
			tempItems: [],
			displayInput: null
		}
	},
	methods: {
		add () {
			const data = this.$refs.activeSelect.model
			this.tempItems.push(data)
			this.$nextTick(() => {
				this.val = ''
			})
		},
		rem (item) {
			this.tempItems.splice(this.tempItems.indexOf(item), 1)
		},
		hndDynamicSelectEmit (data) {
			// console.log(data)
		}
	},
    async beforeMount () {
        await this.$store.dispatch('fetchCurrencies')
    },
	watch: {
		'tempParentItems': {
			handler: function (n) {
				if (n) {
					n.forEach(i => {
						this.tempItems.push(JSON.parse(i))
					})
				}
			},
			immediate: true
		},
		'displayItem': {
			handler: function (n) {
				if (n) {
					this.displayInput = n
				}
			},
			immediate: true
		},
		'providerItem': {
			handler: function (n) {
				if (n) {
					this.providerInput = n
				}
			},
			immediate: true
		}
	}
}
</script>
<style lang="scss">
.dashed-container {
	border: 2px dashed #39424f;
	padding: 10px;
	margin: 10px 10px 10px 0;
	label {
		font-size: 14px;
		background: #3d4857;
		padding: 0.25em 0.5em;
		margin-right: 0.5em;
		border-radius: 3px;
        input[type="radio"] {
            vertical-align: -2px;
            margin-right:10px;
        }
		> svg {
			margin-left: 10px;
			padding:0.25em 0 0;
			transition:transform 0.2s ease-out;
			&:hover {
				color:red;
				transform:scale(1.25);
			}
		}
	}
}
</style>
